<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert outlined type="info" prominent border="left" class="my-10">
          Téléchargez le
          <a href @click.prevent="downloadReport">rapport</a> complet de
          distribution des présents.
        </v-alert>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="mt-10">
      <v-col cols="12" sm="6">
        <div class="title">Cheseaux</div>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="weekday in weekdays.filter((w) => w.location === 'cheseaux')"
            :key="weekday.date"
          >
            <v-expansion-panel-header v-if="weekday.date !== '2021-02-28T00:00:00.000Z'">{{
              weekday.date | formatWeekdayWithDay
            }}</v-expansion-panel-header>
            <v-expansion-panel-header v-else>Jusqu'au 28.02.2021</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="(slot, index) in weekday.slots" :key="slot.date">
                <div
                  class="mt-10"
                  v-if="weekday.date !== '2021-02-28T00:00:00.000Z'"
                >
                  <v-container pa-0>
                    <v-row>
                      <v-col sm="6" v-if="index === 0">Demandes ajoutées</v-col>
                      <v-col sm="6" v-else>{{ slot.date | formatTime }}</v-col>
                      <v-col sm="6" class="text-right" v-if="index === 0">
                        <v-btn
                          icon
                          text
                          small
                          @click="openDialog(slot.date, 'cheseaux')"
                        >
                          <v-icon dark small>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-divider></v-divider>
                </div>
                <div
                  class="mt-10"
                  v-else-if="
                    slot.date === '2021-02-28T11:00:00.000Z' ||
                    slot.date === '2021-02-28T06:30:00.000Z'
                  "
                >
                  <v-container pa-0>
                    <v-row>
                      <v-col sm="6" v-if="index === 0">Demandes ajoutées</v-col>
                      <v-col
                        sm="6"
                        v-else-if="slot.date === '2021-02-28T11:00:00.000Z'"
                        >Inscriptions</v-col
                      >
                      <v-col sm="6" class="text-right" v-if="index === 0">
                        <v-btn
                          icon
                          text
                          small
                          @click="openDialog(slot.date, 'cheseaux')"
                        >
                          <v-icon dark small>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-divider></v-divider>
                </div>
                <div class="mt-5">
                  <v-checkbox
                    v-for="order in slot.orders"
                    :key="order._id"
                    v-model="
                      slot.orders.find((o) => o._id === order._id).delivered
                    "
                    :label="`${order.attendee.firstname} ${
                      order.attendee.lastname
                    } ${
                      order.recipients.length
                        ? `(${order.recipients
                            .map((r) => `${r.firstname} ${r.lastname}`)
                            .join(', ')})`
                        : ''
                    }`"
                    @change="updatePayload(order)"
                    dense
                    class="ma-0 pa-0"
                  ></v-checkbox>
                </div>
              </div>
              <div class="text-right">
                <v-btn text @click="updateOrders">enregistrer</v-btn>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col cols="12" sm="6">
        <div class="title">St-Roch</div>
        <v-expansion-panels>
          <v-expansion-panel
            v-for="weekday in weekdays.filter((w) => w.location === 'st-roch')"
            :key="weekday.date"
          >
            <v-expansion-panel-header v-if="weekday.date !== '2021-02-28T00:00:00.000Z'">{{
              weekday.date | formatWeekdayWithDay
            }}</v-expansion-panel-header>
            <v-expansion-panel-header v-else>Jusqu'au 28.02.2021</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-for="(slot, index) in weekday.slots" :key="slot.date">
                <div
                  class="mt-10"
                  v-if="weekday.date !== '2021-02-28T00:00:00.000Z'"
                >
                  <v-container pa-0>
                    <v-row>
                      <v-col sm="6" v-if="index === 0">Demandes ajoutées</v-col>
                      <v-col sm="6" v-else>{{ slot.date | formatTime }}</v-col>
                      <v-col sm="6" class="text-right" v-if="index === 0">
                        <v-btn
                          icon
                          text
                          small
                          @click="openDialog(slot.date, 'st-roch')"
                        >
                          <v-icon dark small>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-divider></v-divider>
                </div>
                <div
                  class="mt-10"
                  v-else-if="
                    slot.date === '2021-02-28T11:00:00.000Z' ||
                    slot.date === '2021-02-28T06:30:00.000Z'
                  "
                >
                  <v-container pa-0>
                    <v-row>
                      <v-col sm="6" v-if="index === 0">Demandes ajoutées</v-col>
                      <v-col
                        sm="6"
                        v-else-if="slot.date === '2021-02-28T11:00:00.000Z'"
                        >Inscriptions</v-col
                      >
                      <v-col sm="6" class="text-right" v-if="index === 0">
                        <v-btn
                          icon
                          text
                          small
                          @click="openDialog(slot.date, 'st-roch')"
                        >
                          <v-icon dark small>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-divider></v-divider>
                </div>
                <div class="mt-5">
                  <v-checkbox
                    v-for="order in slot.orders"
                    :key="order._id"
                    v-model="
                      slot.orders.find((o) => o._id === order._id).delivered
                    "
                    :label="`${order.attendee.firstname} ${
                      order.attendee.lastname
                    } ${
                      order.recipients.length
                        ? `(${order.recipients
                            .map((r) => `${r.firstname} ${r.lastname}`)
                            .join(', ')})`
                        : ''
                    }`"
                    @change="updatePayload(order)"
                    dense
                    class="ma-0 pa-0"
                  ></v-checkbox>
                </div>
              </div>
              <div class="text-right">
                <v-btn text @click="updateOrders">enregistrer</v-btn>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar.visible"
      :bottom="true"
      :left="true"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.visible = false">Fermer</v-btn>
    </v-snackbar>
    <v-dialog v-model="dialog" width="500px">
      <v-card v-if="dialog">
        <v-card-title>Ajouter une demande</v-card-title>
        <v-card-text>
          <div class="my-5">
            Date: {{ this.order.slot | formatWeekdayFull }}, Lieu:
            {{ this.order.location === "cheseaux" ? "Cheseaux" : "St-Roch" }}
          </div>
          <v-autocomplete
            outlined
            :items="employees"
            v-model="order.idisa"
            label="Rechercher une personne..."
            dense
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeDialog">Annuler</v-btn>
          <v-btn text @click="createOrder">Sauvegarder</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { format, isSameDay, parseISO, isEqual } from "date-fns";
import { fr } from "date-fns/locale";
import fileDownload from "js-file-download";

export default {
  name: "AdminPart",
  sockets: {
    "new-order": function ({ order }) {
      if (
        this.weekdays.find(
          (wd) =>
            isSameDay(parseISO(wd.date), parseISO(order.slot)) &&
            wd.location === order.location
        )
      ) {
        this.weekdays
          .find(
            (wd) =>
              isSameDay(parseISO(wd.date), parseISO(order.slot)) &&
              wd.location === order.location
          )
          .slots.find((s) => isEqual(parseISO(s.date), parseISO(order.slot)))
          .orders.push(order);
      }
      const employees = [order.attendee.idisa];
      employees.map((idisa) => {
        this.employees.find((e) => e.value === idisa).disabled = true;
        Object.assign(this.employees, this.employees);
      });
    },
    "update-orders": function (orders) {
      orders.map((o) => {
        this.weekdays.map((wd) => {
          wd.slots.map((s) => {
            if (s.orders.find((order) => order._id === o._id)) {
              s.orders.find((order) => order._id === o._id).delivered =
                o.delivered;
            }
          });
        });
      });
    },
  },
  async mounted() {
    const { data: weekdays } = await axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URI}/admin/orders`,
    });
    this.weekdays = weekdays;
    const { data: employees } = await axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URI}/admin/employees`,
    });
    this.employees = employees;
  },
  data: () => ({
    dialog: false,
    weekdays: [],
    selected: [],
    employees: [],
    order: {
      idisa: undefined,
      slot: "",
      location: "",
    },
    snackbar: {
      visible: false,
      color: "",
      text: "",
    },
  }),
  methods: {
    async downloadReport() {
      const { data } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_API_URI}/admin/orders/full-export`,
        responseType: "arraybuffer",
      });
      fileDownload(data, "report.xlsx");
    },
    async updateOrders() {
      await axios({
        method: "patch",
        url: `${process.env.VUE_APP_API_URI}/admin/orders`,
        data: this.selected,
      });
      this.snackbar = {
        visible: true,
        color: "success",
        text: "Les mises à jour ont été effectuées avec succès.",
      };
    },
    async createOrder() {
      try {
        const {
          data: { order },
        } = await axios({
          method: "post",
          url: `${process.env.VUE_APP_API_URI}/admin/orders`,
          data: this.order,
        });

        this.weekdays
          .find((wd) => isSameDay(parseISO(wd.date), parseISO(this.order.slot)))
          .slots[0].orders.push(order);
        this.employees.find(
          (e) => e.value === this.order.idisa
        ).disabled = true;
        Object.assign(this.employees, this.employees);
        this.closeDialog();
        this.snackbar = {
          visible: true,
          color: "success",
          text: "Les mises à jour ont été effectuées avec succès.",
        };
      } catch (error) {
        this.snackbar = {
          visible: true,
          color: "error",
          text:
            "Erreur de soumission. Rafraîchissez la page pour mettre à jour les données.",
        };
      }
    },
    updatePayload(value) {
      if (this.selected.find((s) => s._id === value._id)) {
        this.selected.find((s) => s._id === value._id).delivered =
          this.selected.find((s) => s._id === value._id).delivered === false;
      } else {
        this.selected.push({ _id: value._id, delivered: value.delivered });
      }
    },
    openDialog(slot, location) {
      this.order.slot = slot;
      this.order.location = location;
      this.dialog = !this.dialog;
    },
    closeDialog() {
      this.order.idisa = undefined;
      this.order.slot = "";
      this.order.location = "";
      this.dialog = !this.dialog;
    },
  },
  filters: {
    formatWeekday(value) {
      return format(parseISO(value), "dd.MM");
    },
    formatWeekdayWithDay(value) {
      return format(parseISO(value), "EEEE dd.MM", { locale: fr });
    },
    formatWeekdayFull(value) {
      return format(parseISO(value), "dd.MM.yyyy");
    },
    formatTime(value) {
      return format(parseISO(value), "HH:mm");
    },
  },
};
</script>

<style>
.full-width {
  width: 100%;
}
</style>